/* global document */
/**
 * The function returns the truncated summary from start and till the last full-stop.
 * @param {string} articleBodyHtml HTML string to read
 * @returns The truncated summary, an empty string if failed
 */
const getArticleDescription = (articleBodyHtml) => {
    if (!articleBodyHtml) {
        return '';
    }
    // Client-side implementation
    //
    if (typeof document === 'undefined') {
        return null;
    }
    const documentElement = document.createElement('html');
    articleBodyHtml = articleBodyHtml.replace(/<(style|script)[^>]*>[\s\S]*?<\/\1>/gi, '');
    documentElement.innerHTML = articleBodyHtml;
    const str = documentElement.textContent.trim();
    const CHAR_LIMIT = 150;
    let idx = -1;
    while ((idx = str.indexOf('.', idx + 1)) !== -1) {
        if (idx === str.length - 1) {
            return str;
        }
        if (idx >= CHAR_LIMIT) {
            return str.slice(0, idx + 1);
        }
    }
    return str;
};

export default getArticleDescription;